/**
 * Generate image source set for responsive images
 * Currently returns single image path - ready for future multi-size enhancement
 *
 * @param {string} imageName - The base name of the image file (without extension)
 * @param {string} folder - Folder name ('photography' or 'artwork')
 * @returns {object} Object with thumbnail, medium, and full image paths
 */
export function generateImageSrcSet(imageName, folder = 'photography') {
  const basePath = `/images/${folder}/`;

  // For now, using same image for all sizes
  // Future: implement separate sizes with naming convention
  const imagePath = `${basePath}${imageName}.jpg`;

  return {
    thumbnail: imagePath,
    medium: imagePath,
    full: imagePath
  };
}

/**
 * Get image path for a specific size
 *
 * @param {string} imageName - The base name of the image file
 * @param {string} size - Size variant (thumbnail, medium, or full)
 * @param {string} folder - Folder name ('photography' or 'artwork')
 * @returns {string} Image path
 */
export function getImagePath(imageName, size = 'full', folder = 'photography') {
  const srcSet = generateImageSrcSet(imageName, folder);
  return srcSet[size] || srcSet.full;
}
